import { SegmentedRadio } from "./SegmentedRadio.tsx";
import { THEME_CHOICES, type ThemeChoice, themeLabel } from "./theme.ts";
import { useThemeChoice } from "./use-theme.tsx";

/**
 * Три состояния темы в ряд.
 *
 * Один и тот же узел стоит в двух местах: пунктом меню кабинета и за
 * шестерёнкой в комнате урока (решение владельца 02.09.2026). Общим
 * компонентом, а не двумя похожими, ровно ради одного: подписи состояний
 * обязаны совпадать дословно. Человек, увидевший «Как в системе» в кабинете и
 * «Авто» в комнате, решит, что это разные настройки.
 *
 * Применяется сразу по нажатию, без «Сохранить»: тему выбирают глазами, и
 * кнопка подтверждения означала бы выбор вслепую.
 *
 * ⚠️ **Своих классов у ряда больше нет** (14.09.2026). До этого дня это был
 * `.themes` со своим `.themes__btn`, то есть ПЯТЫЙ вид переключателя режима:
 * ряд прямоугольных кнопок с `aria-pressed` при трёх других видах на соседних
 * экранах. Выбор здесь ровно один из трёх, значит это сегмент, и никакого
 * своего вида ему не полагается. Заодно ушла и неправда для читалки:
 * `aria-pressed` объявлял три независимых тумблера там, где выбор один.
 *
 * ⚠️ Ряд переносится, а не сжимается: «Как в системе» это тринадцать знаков, и
 * на узком телефоне сегменты встают в две строки. Сократить подпись до «Авто»
 * нельзя, такого слова вслух никто не говорит.
 */
export function ThemePicker() {
  const [choice, setChoice] = useThemeChoice();

  return (
    <SegmentedRadio
      ariaLabel="Светлая или тёмная"
      segments={THEME_CHOICES.map((option) => ({ id: option, label: themeLabel(option) }))}
      value={choice}
      onPick={(id) => setChoice(id as ThemeChoice)}
    />
  );
}
